import * as layout from '../../../components/markLayout.module.css';
import { MarkButton } from '../../../components/MarkControls';
import React from 'react';
import P from '@hero/ui-kit/typography/P';
import useValidateBlast from '../../../api/useValidateBlast';
import { BLAST_ERROR_LABELS, htmlTemplateErrorLabel } from '../../../constants';
type Props = {
    blastId: number;
    isContentActive: boolean;
    onReviewContent: () => void;
};
const revalidateButton = (onClick: () => void, isRefetching: boolean) => (
    <MarkButton
        type="button"
        onClick={onClick}
        disabled={isRefetching}
        style={{
            marginLeft: '0.8rem'
        }}
    >
        {isRefetching ? 'Checking…' : 'Re-validate'}
    </MarkButton>
);
const ValidateBanner: React.FC<Props> = ({ blastId, isContentActive, onReviewContent }) => {
    const { data, isLoading, isRefetching, error, refetch } = useValidateBlast(blastId);
    const result = data?.data;
    if (isLoading) {
        return (
            <P
                noDefaultMargin
                size="small"
                styles={{
                    color: 'var(--mark-muted)',
                    padding: '0.4rem 0'
                }}
            >
                Validating…
            </P>
        );
    }
    if (error) {
        return (
            <div
                role="alert"
                style={{
                    backgroundColor: 'var(--mark-danger-surface)',
                    marginBottom: '1rem'
                }}
                className={layout.notice}
            >
                <P
                    noDefaultMargin
                    size="small"
                    styles={{
                        color: 'var(--mark-danger)'
                    }}
                >
                    Validation check failed.
                    {revalidateButton(() => refetch(), isRefetching)}
                </P>
            </div>
        );
    }
    if (!result) return null;
    if (result.valid) {
        return (
            <div
                role="status"
                style={{
                    backgroundColor: 'var(--mark-success-surface)',
                    marginBottom: '1rem'
                }}
                className={layout.panel}
            >
                <P
                    noDefaultMargin
                    size="small"
                    styles={{
                        color: 'var(--mark-success)'
                    }}
                >
                    Ready to publish.
                    {result.suppressed_included_count != null && (
                        <>
                            {' '}
                            ({result.suppressed_included_count} suppressed contact
                            {result.suppressed_included_count !== 1 ? 's' : ''} included —
                            transactional bypasses suppression.)
                        </>
                    )}
                    {revalidateButton(() => refetch(), isRefetching)}
                </P>
            </div>
        );
    }
    return (
        <div
            role="alert"
            style={{
                backgroundColor: 'var(--mark-danger-surface)',
                marginBottom: '1rem'
            }}
            className={layout.notice}
        >
            {result.errors.map((err) => (
                <P
                    key={err}
                    noDefaultMargin
                    size="small"
                    styles={{
                        color: 'var(--mark-danger)'
                    }}
                >
                    {BLAST_ERROR_LABELS[err] ?? htmlTemplateErrorLabel(err)}
                </P>
            ))}
            <div className={layout.confirmActions}>
                {!isContentActive &&
                    result.errors.some(
                        (code) =>
                            code.startsWith('html_') ||
                            code.startsWith('template_') ||
                            code === 'missing_subject' ||
                            code === 'variable_requires_target_kind'
                    ) && <MarkButton onClick={onReviewContent}>Review email content</MarkButton>}
                {revalidateButton(() => refetch(), isRefetching)}
            </div>
        </div>
    );
};
export default ValidateBanner;
